import {
  defineNamespace,
  type FlowT,
  type StringKey,
} from "../../../../i18n/define-namespace";
import { WGL_SUPPORT_PHONE } from "../../../constants";
import en from "./en.json";
import es from "./es.json";

/**
 * All user-facing strings of the WGL appointment flow. Registered at module
 * scope so the bundle lands in whichever module graph (RSC or client)
 * evaluates it — `use-t.ts` and `server.ts` both import this file.
 */
export const appointmentNamespace = defineNamespace({
  ns: "wgl-appointment",
  en,
  es,
  defaults: { phone: WGL_SUPPORT_PHONE },
});
appointmentNamespace.register();

export type AppointmentResources = typeof en;
export type AppointmentT = FlowT<AppointmentResources>;
export type AppointmentKey = StringKey<AppointmentResources>;
